import _ from 'lodash';
import { apiSearch, apiFetch } from './utility';

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : 'user',
			dispatch,
			callback,
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'user.get',
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'user.add',
			listNameToUpdate : 'userIds',
			params,
			dispatch,
			successMessage : `User was created successfully. 
				Click continue to return to the user page`,
			onSuccessRedirectTo : '/users',
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'user.update',
			params,
			dispatch,
			successMessage : `User was updated successfully. 
				Click continue to return to the user page`,
			onSuccessRedirectTo : '/users',
			callback,
		});
	};
};
